import type { Environment } from "../ApplicationContext";
import type { AdpEnv, AnalyticsConfig } from "./types";

const ADP_ENV: Record<Environment["REACT_APP_ENV"], AdpEnv> = {
    prod: "prd",
    stg: "stg",
    dev: "dev",
    local: "dev",
};

/** The ADP environment derives from `REACT_APP_ENV` so the two cannot drift. */
export function buildAnalyticsConfig(env: Environment): AnalyticsConfig {
    const isProduction = env.REACT_APP_ENV === "prod";
    const productName = env.ADP_PRODUCT_NAME ?? "";
    return {
        // An empty product name selects the console fallback, which is for non-production only.
        enabled: env.ANALYTICS_ENABLED === "true" && !(isProduction && !productName),
        env: ADP_ENV[env.REACT_APP_ENV] ?? "stg",
        productName,
        productId: env.REACT_APP_CLIENT_ID,
        productLineName: env.ADP_PRODUCT_LINE_NAME || undefined,
        isProduction,
    };
}
